import React, { useEffect } from "react";
import styles from "@/components/FontPanelGoogle.module.css";

const GoogleFontPreview = ({ font, virtualRow, onSelect, isEntireFontInTheme, styleHolder }) => {
  const fontFamily = font.family;
  const fontUrl = font.files.regular;

  const loadFont = () => {
    const fontFaceName = `${fontFamily}-lazy`;

    const style = document.createElement("style");
    style.textContent = `
      @font-face {
        font-family: '${fontFaceName}';
        src: url('${fontUrl}') format('woff2');
        font-display: swap;
      }
    `;
    styleHolder.appendChild(style);
  };
  useEffect(() => {
    loadFont();
  }, []);

  const isFontDisabled = isEntireFontInTheme(font);

  const fontStyle = {
    fontFamily: `${fontFamily}-lazy, sans-serif`,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    transform: `translateY(${virtualRow.start}px)`,
    paddingLeft: "1rem",
  };

  return (
    <div
      className={`${styles["font-preview-option"]} ${
        isFontDisabled ? styles["font-preview-option-disabled"] : ""
      }`}
      style={fontStyle}
      onClick={() => !isFontDisabled && onSelect(fontFamily, font)}
    >
      {fontFamily}
    </div>
  );
};

export default GoogleFontPreview;
